import * as React from 'react';

/**
 * Main page container, wrapping whole page content.
 */
export default class PageContentView extends React.Component<{}, {}> {
	render() {
		return (
			<div className={"m-content l-page-content"}>
				{this.props.children}
			</div>
		);
	}
}